import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { LAYOUT_TYPE_FULL } from 'redux/Settings/constants'
import { changeLayoutType } from 'redux/Settings/actions'

import OnboardingNow from '../../containers/OnboardingNow'
import OnboardingRegisterNow from '../../containers/OnboardingNow/Register'
import PrivateRouteNow from '../PrivateRoute/PrivateRouteNow'

class OnboardingRoutes extends React.Component {
    componentDidMount() {
        const { changeLayoutType } = this.props

        changeLayoutType(LAYOUT_TYPE_FULL)
    }

    render() {
        return (
            <Switch>
                <Route exact path="/now/register" component={OnboardingRegisterNow} />
                <PrivateRouteNow exact path="/now/start" component={OnboardingNow} />
            </Switch>
        )
    }
}

const mapActionsToProps = dispatch => ({
    changeLayoutType: bindActionCreators(changeLayoutType, dispatch)
})

export default connect(
    null,
    mapActionsToProps
)(OnboardingRoutes)
